import React, { useState, useMemo } from "react";
import { Checkbox, Select, Col, Row, Tag, Flex, Button } from "antd";
import exploreCountryImg from "../assets/images/ex-country-1.jpg";
import exploreCountryTwoImg from "../assets/images/ex-country-2.jpg";
import exploreCountryThreeImg from "../assets/images/ex-country-3.jpg";
import { useNavigate } from "react-router-dom";

const { Option } = Select;

// Country → Cities
const countryCityMap = {
  "United Arab Emirates": [
    "Abu Dhabi",
    "Dubai",
    "Sharjah",
    "Ajman",
    "Ras Al Khaimah",
  ],
  Switzerland: ["Zurich", "Lucerne", "Interlaken", "Bern"],
  Italy: ["Rome", "Florence", "Venice", "Milan"],
};

const categories = [
  "Attraction",
  "Parks",
  "Yacht",
  "Holiday Packages",
  "Water Adventures",
  "Hotel",
  "Car Rental",
  "Dinner Cruise",
  "Sky Adventures",
];

// Tours data
const tours = [
  {
    id: 1,
    image: exploreCountryImg,
    price: "INR 1,43,200",
    oldPrice: "INR 2,65,185",
    savings: "SAVE INR 1,21,985",
    type: "Standard",
    tagColor: "blue",
    badgeColor: "#10239E",
    country: "Switzerland",
    city: "Zurich",
    categories: ["Parks", "Attraction"],
  },
  {
    id: 2,
    image: exploreCountryTwoImg,
    price: "INR 1,20,000",
    oldPrice: "INR 1,85,000",
    savings: "SAVE INR 65,000",
    type: "Premium",
    tagColor: "gold",
    badgeColor: "#D72638",
    country: "Italy",
    city: "Rome",
    categories: ["Parks"],
  },
  {
    id: 3,
    image: exploreCountryThreeImg,
    price: "INR 98,000",
    oldPrice: "INR 1,60,000",
    savings: "SAVE INR 62,000",
    type: "Value",
    tagColor: "green",
    badgeColor: "#D72638",
    country: "United Arab Emirates",
    city: "Dubai",
    categories: ["Water Adventures"],
  },
  {
    id: 4,
    image: exploreCountryImg,
    price: "INR 75,000",
    oldPrice: "INR 1,20,000",
    savings: "SAVE INR 45,000",
    type: "Standard",
    tagColor: "blue",
    badgeColor: "#10239E",
    country: "United Arab Emirates",
    city: "Abu Dhabi",
    categories: ["Attraction", "Water Adventures"],
  },
  {
    id: 5,
    image: exploreCountryTwoImg,
    price: "INR 1,50,000",
    oldPrice: "INR 2,10,000",
    savings: "SAVE INR 60,000",
    type: "Premium",
    tagColor: "gold",
    badgeColor: "#D72638",
    country: "Italy",
    city: "Venice",
    categories: ["Parks", "Hotel", "Water Adventures"],
  },
  {
    id: 6,
    image: exploreCountryTwoImg,
    price: "INR 1,50,000",
    oldPrice: "INR 2,10,000",
    savings: "SAVE INR 60,000",
    type: "Premium",
    tagColor: "gold",
    badgeColor: "#D72638",
    country: "Italy",
    city: "Venice",
    categories: ["Attraction", "Water Adventures"],
  },
  {
    id: 7,
    image: exploreCountryTwoImg,
    price: "INR 1,50,000",
    oldPrice: "INR 2,10,000",
    savings: "SAVE INR 60,000",
    type: "Premium",
    tagColor: "gold",
    badgeColor: "#D72638",
    country: "Italy",
    city: "Venice",
    categories: ["Parks", "Hotel", "Water Adventures"],
  },
  {
    id: 8,
    image: exploreCountryTwoImg,
    price: "INR 1,50,000",
    oldPrice: "INR 2,10,000",
    savings: "SAVE INR 60,000",
    type: "Premium",
    tagColor: "gold",
    badgeColor: "#D72638",
    country: "Italy",
    city: "Venice",
    categories: ["Attraction", "Water Adventures", "Hotel"],
  },
];

const FilterSection = ({ selectedFilters, setSelectedFilters }) => {
  const handleCountryChange = (value) => {
    setSelectedFilters((prev) => ({
      ...prev,
      country: value,
      cities: [], // reset cities when country changes
    }));
  };

  const handleCityChange = (checkedValues) => {
    setSelectedFilters((prev) => ({ ...prev, cities: checkedValues }));
  };

  const handleCategoryChange = (checkedValues) => {
    setSelectedFilters((prev) => ({ ...prev, categories: checkedValues }));
  };

  return (
    <div className="p-6 w-full md:w-[20%] sticky top-0 h-fit self-start">
      {/* Country */}
      <div className="mb-6">
        <h2 className="text-xl font-normal mb-3">Country / City</h2>
        <Select
          placeholder="Select Country"
          onChange={handleCountryChange}
          className="w-full"
          allowClear
          value={selectedFilters.country}
        >
          {Object.keys(countryCityMap).map((country, index) => (
            <Option key={index} value={country}>
              {country}
            </Option>
          ))}
        </Select>
      </div>

      {/* City */}
      {selectedFilters.country && (
        <div className="mb-6">
          <h2 className="text-xl font-normal mb-3">City</h2>
          <Checkbox.Group
            className="flex flex-col space-y-2"
            onChange={handleCityChange}
            value={selectedFilters.cities}
          >
            {countryCityMap[selectedFilters.country].map((city, index) => (
              <Checkbox key={index} value={city}>
                {city}
              </Checkbox>
            ))}
          </Checkbox.Group>
        </div>
      )}

      {/* Category Types */}
      <div>
        <h2 className="text-xl font-normal mb-3">Category Types</h2>
        <Checkbox.Group
          className="flex flex-col space-y-4"
          onChange={handleCategoryChange}
          value={selectedFilters.categories}
        >
          {categories.map((cat, index) => (
            <Checkbox
              key={index}
              value={cat}
              className="
            font-normal
            [&_.ant-checkbox-inner]:border-[#0A2381]/10
            [&_.ant-checkbox-inner]:bg-[#0A2381]
            [&_.ant-checkbox-inner]:bg-[#0A2381]/10  
            [&_.ant-checkbox-checked_.ant-checkbox-inner]:bg-primary
            [&_.ant-checkbox-checked_.ant-checkbox-inner]:border-primary
          
             hover:[&_.ant-checkbox-inner]:border-primary
            hover:[&_.ant-checkbox-inner]:bg-primary/10
            "
            >
              {cat}
            </Checkbox>
          ))}
        </Checkbox.Group>
      </div>
    </div>
  );
};

export default function CategorySection() {
  const [selectedFilters, setSelectedFilters] = useState({
    country: null,
    cities: [],
    categories: [...categories], // ✅ All Activities selected by default
  });

  const [visibleCount, setVisibleCount] = useState(() =>
    categories.reduce((acc, cat) => {
      acc[cat] = 3;
      return acc;
    }, {})
  );

  // Group tours by categories AFTER applying filters
  const groupedTours = useMemo(() => {
    let filtered = tours.filter((tour) => {
      if (selectedFilters.country && tour.country !== selectedFilters.country)
        return false;
      if (
        selectedFilters.cities.length > 0 &&
        !selectedFilters.cities.includes(tour.city)
      )
        return false;
      if (
        selectedFilters.categories.length > 0 &&
        !tour.categories.some((cat) => selectedFilters.categories.includes(cat))
      )
        return false;
      return true;
    });

    // Group by categories
    let grouped = {};
    categories.forEach((cat) => {
      grouped[cat] = filtered.filter((tour) => tour.categories.includes(cat));
      // if (selectedFilters.categories.includes(cat)) {

      // }
    });
    return grouped;
  }, [selectedFilters]);

  const handleSeeMore = (cat) => {
    setVisibleCount((prev) => ({
      ...prev,
      [cat]: prev[cat] + 3,
    }));
  };
const navigate = useNavigate();
  return (
    <div className="container">
      <div className="flex flex-col md:flex-row border border-[#CCE1F9] min-h-[600px]">
        {/* Left: Cards grouped by Category */}
        <div className="p-6 w-full md:w-[80%] space-y-10 border-r border-[#CCE1F9]">
          {categories.map((cat) =>
            selectedFilters.categories.includes(cat) &&
            groupedTours[cat] &&
            groupedTours[cat].length > 0 ? (
              <div key={cat}>
                <h2 className="text-xl font-normal text-primary mb-4">{cat}</h2>
                <Row gutter={[20, 40]} align="stretch">
                  {groupedTours[cat].slice(0, visibleCount[cat]).map((tour) => (
                    <Col xs={24} md={8} key={tour.id}>
                      <div  onClick={() => navigate('/deal-flight-hotel')} 
                      className="cursor-pointer h-[100%] bg-white rounded-xl overflow-hidden relative shadow-lg hover:shadow-2xl">
                        {/* Image */}
                        <div className="relative">
                          <div className="absolute overflow-hidden bg-black/20 w-full h-[100%] ">
                            <div className="absolute bottom-0 left-0 right-0 p-4 text-left">
                              <div className="text-base font-semibold text-white">
                                INR 1,43,200
                              </div>
                              <div className="line-through font-normal text-white text-md">
                                INR 2,65,185
                              </div>
                              <div className="font-normal text-white text-md">
                                SAVE INR 1,21,985
                              </div>
                            </div>
                          </div>
                          <img
                            src={tour.image}
                            alt="Tour"
                            className="w-full h-[170px] object-cover"
                          />
                          {/* Rating Badge */}
                          <div
                            className={`bg-primary absolute bottom-[-25px] right-6 rounded-full shadow-lg text-white text-sm flex  justify-center w-[80px] h-[80px] ${tour.badgeColor}`}
                          >
                            <div className="text-center leading-tight mt-2">
                              <div className="text-3xl">★</div>
                              <div className="text-xs font-normal">
                                4.9 (523)
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Content */}
                        <div className="p-5 pt-3">
                          {/* <div class="pt-3 bg-gray-100">This will have visible top padding</div> */}
                          <div className="mt-3 mb-2 text-muted text-[11px] font-medium">
                            Tour Type
                            <Tag className="bg-blue-100 text-black font-medium rounded border-0 text-[11px] ml-2">
                              {tour.type}
                            </Tag>
                          </div>

                          <div className="font-medium text-black text-md leading-snug">
                            Best of Switzerland & Italy with <br />
                            FREE Excursion to Mount Titlis
                          </div>

                          <div className="text-primary mt-2 font-medium">
                            9 days & 8 nights
                          </div>

                          <div className="text-[11px] text-muted mt-3 space-x-1 font-medium">
                            <span className="text-red-500 font-semibold">
                              2D
                            </span>{" "}
                            Rome →
                            <span className="text-red-500 font-semibold">
                              1D
                            </span>{" "}
                            Florence →{" "}
                            <span className="text-red-500 font-semibold">
                              2D
                            </span>{" "}
                            Venice →{" "}
                            <span className="text-red-500 font-semibold">
                              4D
                            </span>{" "}
                            Zurich
                          </div>
                        </div>
                      </div>
                    </Col>
                  ))}
                </Row>
                {/* Show See More only if there are more tours to show */}
                {visibleCount[cat] < groupedTours[cat].length && (
                  <Flex justify="center" align="center" className="mt-10">
                    <Button
                      onClick={() => handleSeeMore(cat)}
                      size="middle"
                      type="default"
                      className="font-semibold w-60 py-6 text-sm rounded-tl-[12px] rounded-bl-none rounded-tr-none rounded-br-[12px] border-gray-400 text-danger rounded-lg"
                    >
                      See More
                    </Button>
                  </Flex>
                )}
              </div>
            ) : null
          )}
        </div>

        {/* Right: Filters */}
        <FilterSection
          selectedFilters={selectedFilters}
          setSelectedFilters={setSelectedFilters}
        />
      </div>
    </div>
  );
}
